import
{
  firebaseLoginGoogle,
  firebaseLogout,
  firebaseDeleteUser,
  firebaseGetToken,
  firebaseGetUser,
  firebaseAuthListener
} from "./firebase";

import
{
  apiLoginGoogle,
  apiLoginEmail,
  apiGetUserByTokenId,
  apiGetUserByToken,
  logOutUserFunction
} from "./api";

// ================= BASIC DATA ========================

let MainDataToStoreCookies =
{
    mtdPINGType:null,
    fbPINGData:null,
    emPINGData:null,
}

export let MainSession =
{
  usd_PING_id: null,
  pvd_PING: null,
  usd_PING_tkn: null
};

export let BasicInfoSession =
{
    first_name: null,
    last_name: null,
    prof_pic: null,
    no: null
}

/* ================= COOKIES ================= */

const COOKIE_KEY = "APP_USER";
const COOKIE_KEY_2 = "IM_Ping_INFO";
const COOKIE_KEY_3 = "U_Ping_INFO";

const saveCookieUser = (data, wheretostore, whatname) =>
{
  wheretostore.setItem(whatname, btoa(JSON.stringify(data)));
};


// =================== FOR AUTO SET AND LOAD ================================

const SetBasicInfoSession = async () =>
{
    BasicInfoSession =
    {
        first_name: null,
        last_name: null,
        prof_pic: null,
        no: null
    }

    let CurrentUserData = sessionStorage.getItem(COOKIE_KEY_2);
    if(CurrentUserData != null)
    {
        let DecodedUserData = JSON.parse(atob(CurrentUserData));
        const UserDataInfoByIdToken = await apiGetUserByTokenId(DecodedUserData.usd_PING_id, DecodedUserData.usd_PING_tkn);
        console.log(UserDataInfoByIdToken);

        BasicInfoSession =
        {
            first_name: UserDataInfoByIdToken.data.data.first_name,
            last_name: UserDataInfoByIdToken.data.data.last_name,
            prof_pic: UserDataInfoByIdToken.data.data.member_pings.profile_picture,
            no: UserDataInfoByIdToken.data.data.id
        };
        console.log("User Basic Info:", BasicInfoSession);
        sessionStorage.setItem(COOKIE_KEY_3, btoa(JSON.stringify(BasicInfoSession)));
    }

    return BasicInfoSession;
};

export const clearCookieUser = () =>
{
  localStorage.removeItem(COOKIE_KEY);
  sessionStorage.removeItem(COOKIE_KEY_2);
  sessionStorage.removeItem(COOKIE_KEY_3);
};

/* ================= INIT ================= */

export const initAuth = async (callback) =>
{
  /* ================= FAST PATH ================= */
  // 1) MainSession exists (sessionStorage / memory)
  if(sessionStorage.getItem(COOKIE_KEY_2))
  {
    MainSession = JSON.parse(atob(sessionStorage.getItem(COOKIE_KEY_2)));

    if(sessionStorage.getItem(COOKIE_KEY_3))
    {
      BasicInfoSession = JSON.parse(atob(sessionStorage.getItem(COOKIE_KEY_3)));
    }
    else
    {
      await SetBasicInfoSession();
    }

    callback(true);
    return;
  }

  /* ================= EMAIL LOGIN RESTORE ================= */
  // 2) Normal email login cookie exists
  if (localStorage.getItem(COOKIE_KEY))
  {
    const ThisLoginData = JSON.parse(atob(localStorage.getItem(COOKIE_KEY)));
    let WhichNormalLoginData = ThisLoginData.emPINGData.replaceAll("%20;", ",")
    const NormalLoginData = JSON.parse(WhichNormalLoginData);

    const userToken = NormalLoginData.cache;


    try
    {
      // Only hit backend if userId not cached
      const UserDataByToken = await apiGetUserByToken(userToken);
      const userId = UserDataByToken.data.data.id_user;

      MainSession = {
        usd_PING_id: userId,
        pvd_PING: "pingingo",
        usd_PING_tkn: userToken
      };

      saveCookieUser(MainSession, sessionStorage, COOKIE_KEY_2);
      await SetBasicInfoSession();

      callback(true);
      return;
    }
    catch (err)
    {
      // console.error("Firebase restore failed:", err);

      // 🔥 CLEAR ALL LOCAL SESSION
      clearCookieUser();

      MainSession = null;
      BasicInfoSession = null;

      callback(false);
    }
  }

  /* ================= FIREBASE RESTORE ================= */
  // 3) Firebase session restore
  firebaseAuthListener(async (user) =>
  {
    // if(IsGoogleLoginInProgress)
    // {
    //     return;
    // }

    if (!user)
    {
      // No firebase session
      clearCookieUser();
      MainSession = null;
      BasicInfoSession = null;

      callback(false);
      return;
    }

    try
    {
      // Firebase user exists → Google login restore
      const FireBasetoken = await firebaseGetToken();

      const formData = new FormData();
      formData.append('email', user.email);
      formData.append('lang', window.CurrentCountryID || '');
      formData.append('name', user.displayName || '');
      formData.append('photo', user.photoURL || '');
      formData.append('tenant_id', user.tenantId || '');
      formData.append('token_firebase', FireBasetoken);
      formData.append('uid', user.uid);
      await window.getBrowserData(formData);
      console.log(window.ConvertFormDataToJSON(formData));
      const authRes = await apiLoginGoogle(formData);
      const userToken = authRes.data.data.token;

      const UserDataByToken = await apiGetUserByToken(userToken);
      const userId = UserDataByToken.data.data.id_user;

      MainSession = {
        usd_PING_id: userId,
        pvd_PING: "google",
        usd_PING_tkn: userToken
      };

      saveCookieUser(MainSession, sessionStorage, COOKIE_KEY_2);
      await SetBasicInfoSession();

      callback(true);
    }
    catch (err)
    {
      // console.error("Firebase restore failed:", err);

      // 🔥 FORCE FIREBASE LOGOUT
      await firebaseLogout();

      // 🔥 CLEAR ALL LOCAL SESSION
      clearCookieUser();

      MainSession = null;
      BasicInfoSession = null;

      callback(false);
    }

  });
};

/* ================= LOGIN ================= */

// var IsGoogleLoginInProgress = false;

export const loginauthservice = async (type, getformData, callback) =>
{
  let flow = {
    ok: true,
    error: null,
    MainSession: null,
    BasicInfoSession: null,
    loggedin: false
  };

  MainSession = {
    usd_PING_id: null,
    pvd_PING: null,
    usd_PING_tkn: null
  };

  MainDataToStoreCookies = {
    mtdPINGType: type,
    fbPINGData: null,
    emPINGData: null,
  };

  let userToken = null;
  let userId = null;

  try
  {
    /* ================= EMAIL LOGIN ================= */
    if (type === "pingingo")
    {
      console.log("=================== Login By Email ===================");

      const authRes = await apiLoginEmail(getformData);
      userToken = authRes.data.data.token;

      let PinginGoData = {
        cache: authRes.data.data.token,
        time_data: authRes.data.data.expired_at,
        platform: authRes.data.data.platform,
        provider: authRes.data.data.provider,
      };

      let DataToAsign = JSON.stringify(PinginGoData).replaceAll(",", "%20;");
      MainDataToStoreCookies.emPINGData = DataToAsign;

      saveCookieUser(MainDataToStoreCookies, localStorage, COOKIE_KEY);
    }

    /* ================= GOOGLE LOGIN ================= */
    else if (type === "google")
    {
      // IsGoogleLoginInProgress = true;

      console.log("=================== Login By Google ===================");

      await firebaseLoginGoogle();
      if (callback)
      {
        callback(flow);
      }
      return

      const user = firebaseGetUser();
      if (!user) throw new Error("FIREBASE_USER_NOT_FOUND");

      const FireBasetoken = await firebaseGetToken();

      const formData = new FormData();
      await window.getBrowserData(formData);
      formData.append('email', user.email);
      formData.append('lang', window.CurrentCountryID || '');
      formData.append('name', user.displayName || '');
      formData.append('photo', user.photoURL || '');
      formData.append('tenant_id', user.tenantId || '');
      formData.append('token_firebase', FireBasetoken);
      formData.append('uid', user.uid);

      const authRes = await apiLoginGoogle(formData);
      userToken = authRes.data.data.token;

      // IsGoogleLoginInProgress = false;
    }

    /* ================= USER ID ================= */
    console.log("=================== Get User ID by Token ===================");

    const UserDataByToken = await apiGetUserByToken(userToken);
    userId = UserDataByToken.data.data.id_user;

    if (UserDataByToken.data.data.status_account !== "Active")
    {
      throw new Error("ACCOUNT_DISABLED");
    }

    /* ================= SESSION ================= */
    MainSession = {
      usd_PING_id: userId,
      pvd_PING: type,
      usd_PING_tkn: userToken
    };

    saveCookieUser(MainSession, sessionStorage, COOKIE_KEY_2);

    /* ================= BASIC INFO ================= */
    await SetBasicInfoSession();

    /* ================= FLOW SUCCESS ================= */
    flow.ok = true;
    flow.loggedin = true;
    flow.MainSession = MainSession;
    flow.BasicInfoSession = BasicInfoSession;

  }
  catch (err)
  {
    flow.ok = false;
    flow.loggedin = false;
    flow.error = err.response?.data || { message: err.message };
  }

  /* ================= CALLBACK ================= */
  if (callback)
  {
    callback(flow);
  }
};

/* ================= LOGOUT ================= */

export const logoutauthservice = async (callback) =>
{
  let flow =
  {
    ok: true,
    error: null,
  };
  
  try
  {
    await firebaseLogout();
    clearCookieUser();

    flow.ok = true;
  }
  catch (err)
  {
    flow.ok = false;
    flow.error = err.response?.data || { message: err.message };
  }

  if(callback)
  {
    callback(flow);
  }
};

/* ================= DELETE ================= */

export const deleteAccount = async () => {
  await firebaseDeleteUser();
  clearCookieUser();
  MainSession = { firebaseUser: null, backendUser: null, token: null };
};

/* ================= GETTERS ================= */

export const getSession = () => MainSession;
export const getToken = () => MainSession.token;
export const getUser = () => MainSession.backendUser;
